import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import DayMonth from '../DayMonth';
import DayNumber from '../DayMonth/DayNumber';
import Month from '../DayMonth/Month';
import DayText from '../DayMonth/DayText';

const StyledCalendarEventDate = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.dark}1A;
  color: ${props => props.theme.colors.light};
  display: flex;
  height: auto;
  justify-content: space-between;
  padding: ${rem('10px')} ${rem('5px')} ${rem('10px')} ${rem('16px')};
  position: relative;
  ${mediaqueries.greaterThan('desktop')`
    padding:  ${rem('30px')};
    justify-content: center;
  `};
`;
const StyledDragIcon = styled.div`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.light};
  border-top: ${rem('1px')} solid ${props => props.theme.colors.light};
  cursor: pointer;
  display: block;
  height: ${rem('4px')};
  position: absolute;
  top: ${rem('5px')};
  left: 50%;
  width: ${rem('18px')};
  margin: ${rem('5px')} 0 0 ${rem('-9px')};
  ${mediaqueries.greaterThan('mobile')`
    display:none;
  `};
`;

const StyledDateDayMonth = styled(DayMonth)`
  color: #fff;
  display: flex;
`;

// Ya esta float y solo en menor de desktop es none
const StyledDayNumber = styled(DayNumber)`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  display: none;
  margin: 0 ${rem('5px')} 0 0;

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('60px')};
    display: block;
  `};
`;

const StyledDayNumberNoDesktop = styled(StyledDayNumber)`
  display: block;
  ${mediaqueries.greaterThan('desktop')`
    display:none;
  `};
`;

const StyledDateRight = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  padding-bottom: ${rem('0px')};
  ${mediaqueries.greaterThan('desktop')`
     padding-bottom: ${rem('5px')};
     flex-direction: column;
  `};
`;

const StyledMonth = styled(Month)`
  font-size: ${rem('12px')};
  font-family: ${props => props.theme.fonts.medium};

  ${mediaqueries.lessThan('desktop')`
  
    margin: 0 5px 0 0;
  `};

  ${mediaqueries.greaterThan('mobile')`
     font-size: ${rem('14px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
     padding-top: ${rem('10px')};
  `};
`;

const StyledDayText = styled(DayText)`
  font-size: ${rem('12px')};
  font-family: ${props => props.theme.fonts.medium};
  padding-right: ${rem('5px')};

  ${mediaqueries.greaterThan('mobile')`
     padding-left: ${rem('12px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
      font-family: ${props => props.theme.fonts.book};
      font-size: ${rem('14px')};
      padding-top: ${rem('10px')};
      padding-right: 0;
      padding-left: 0;
  `};
`;

export {
  StyledCalendarEventDate,
  StyledDateDayMonth,
  StyledDayNumber,
  StyledMonth,
  StyledDayText,
  StyledDateRight,
  StyledDayNumberNoDesktop,
  StyledDragIcon
};
